var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-wrap"},[_c('div',[_vm._v("Copyright © 2023 中共宁波市委人才工作领导小组办公室 版权所有")]),_c('div',[_vm._v("工信部备案：浙ICP备05064032号-3")])])
}]

export { render, staticRenderFns }